<script setup>
import { ref } from 'vue';
const tab = ref({
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
})
const content1= ref()
const content2= ref()
const content3= ref()
const content4= ref()
const content5= ref()
const content6= ref()
const changeTab = (i,event)=>{
  tab.value[i] = !tab.value[i]
}
</script>
<template>
  <main class="mt-[60px] md:mt-[70px]">
    <div>
      <div class="mx-auto max-w-[960px] px-4 pb-4 lg:px-0">
        <div class="opacity-75 md:opacity-100">
          <div
            class="no-scrollbar mt-4 flex overflow-x-auto pt-4 md:mt-6"
            aria-label="Breadcrumb"
          >
            <ol class="inline-flex items-center">
              <li>
                <div class="flex items-center text-sm font-normal">
                  <a
                    href="/"
                    class="whitespace-nowrap text-gray-accent3 hover:text-breadcrumb-link-hover"
                    >Upstox</a
                  >
                  <div class="px-2">/</div>
                </div>
              </li>
              <li>
                <div class="flex items-center text-sm font-normal">
                  <a
                    href="/calculator/"
                    class="whitespace-nowrap text-gray-accent3 hover:text-breadcrumb-link-hover"
                    >Calculators</a
                  >
                  <div class="px-2">/</div>
                </div>
              </li>
              <li
                class="w-50 truncate pr-7 text-sm font-normal text-lighter-black sm:w-72"
              >
                Income Tax Calculator
              </li>
            </ol>
          </div>
          <h1
            class="my-1 text-lg font-semibold tracking-[-0.24px] text-dark-6 md:my-2 md:text-2xl"
          >
            Income Tax Calculator - Calculate Tax for FY 2025-26
          </h1>
          <p
            class="mb-7 text-[13px] font-normal leading-6 text-black md:mb-9 md:text-base md:font-medium"
          >
            The Income Tax Calculator by Upstox will help you calculate your tax
            liability for Financial Year 2024-25 (Assessment Year 2025-26) and
            FY 2025-26 (AY 2026-27). With this tax calculator, you can compare
            taxes under the New Tax Regime and Old Tax Regime as per your
            income-tax slabs, rates, deductions, and exemptions and decide which
            of the two regimes is best for you.
          </p>
        </div>
        <div
          class="md:shadow-[0px_0px_10px_0px_rgba(177,177,177,0.25) mb-[60px] rounded-3xl border-grey-7 md:mb-10 md:border md:p-[36px]"
        >
          <h2
            class="mb-5 text-base font-medium leading-6 md:mb-6 md:text-xl md:leading-7"
          >
            Calculate your income tax liability
          </h2>
          <div
            class="mb-5 flex w-full items-start justify-between md:mb-9 md:items-center md:gap-2"
          >
            <div class="flex items-start md:items-center md:gap-2">
              <div
                class="flex cursor-pointer flex-col items-center justify-between gap-2 md:flex-row"
              >
                <div>
                  <div
                    class="flex h-[20px] w-[20px] items-center justify-center rounded-full border border-dark-2 text-[10px] text-main-6"
                  >
                    1
                  </div>
                </div>
                <div class="flex flex-col">
                  <span
                    class="max-w-[51px] text-center text-[10px] font-semibold md:max-w-[200px] md:text-left md:text-sm text-main-6"
                    >Basic details</span
                  >
                </div>
              </div>
              <div
                class="mt-[10px] h-[1px] w-[30px] bg-grey-8 md:mt-0 md:w-[41px]"
              ></div>
            </div>
            <div class="flex items-start md:items-center md:gap-2">
              <div
                class="flex cursor-pointer flex-col items-center justify-between gap-2 md:flex-row"
              >
                <div>
                  <div
                    class="flex h-[20px] w-[20px] items-center justify-center rounded-full border border-dark-2 text-[10px] text-dark-2"
                  >
                    2
                  </div>
                </div>
                <div class="flex flex-col">
                  <span
                    class="max-w-[51px] text-center text-[10px] font-semibold md:max-w-[200px] md:text-left md:text-sm text-dark-2"
                    >Income details</span
                  >
                </div>
              </div>
              <div
                class="mt-[10px] h-[1px] w-[30px] bg-grey-8 md:mt-0 md:w-[41px]"
              ></div>
            </div>
            <div class="flex items-start md:items-center md:gap-2">
              <div
                class="flex cursor-pointer flex-col items-center justify-between gap-2 md:flex-row"
              >
                <div>
                  <div
                    class="flex h-[20px] w-[20px] items-center justify-center rounded-full border border-dark-2 text-[10px] text-dark-2"
                  >
                    3
                  </div>
                </div>
                <div class="flex flex-col">
                  <span
                    class="max-w-[51px] text-center text-[10px] font-semibold md:max-w-[200px] md:text-left md:text-sm text-dark-2"
                    >HRA &amp; other allowances</span
                  >
                </div>
              </div>
              <div
                class="mt-[10px] h-[1px] w-[30px] bg-grey-8 md:mt-0 md:w-[41px]"
              ></div>
            </div>
            <div class="flex items-start md:items-center md:gap-2">
              <div
                class="flex cursor-pointer flex-col items-center justify-between gap-2 md:flex-row"
              >
                <div>
                  <div
                    class="flex h-[20px] w-[20px] items-center justify-center rounded-full border border-dark-2 text-[10px] text-dark-2"
                  >
                    4
                  </div>
                </div>
                <div class="flex flex-col">
                  <span
                    class="max-w-[51px] text-center text-[10px] font-semibold md:max-w-[200px] md:text-left md:text-sm text-dark-2"
                    >Deductions</span
                  >
                </div>
              </div>
              <div
                class="mt-[10px] h-[1px] w-[30px] bg-grey-8 md:mt-0 md:w-[41px]"
              ></div>
            </div>
            <div class="flex items-start md:items-center md:gap-2">
              <div
                class="flex cursor-pointer flex-col items-center justify-between gap-2 md:flex-row"
              >
                <div>
                  <div
                    class="flex h-[20px] w-[20px] items-center justify-center rounded-full border border-dark-2 text-[10px] text-dark-2"
                  >
                    5
                  </div>
                </div>
                <div class="flex flex-col">
                  <span
                    class="max-w-[51px] text-center text-[10px] font-semibold md:max-w-[200px] md:text-left md:text-sm text-dark-2"
                    >Summary</span
                  >
                </div>
              </div>
              <div
                class="mt-[10px] h-[1px] w-[30px] bg-grey-8 md:mt-0 md:w-[41px] hidden"
              ></div>
            </div>
          </div>
          <form>
            <h2
              class="mb-4 text-lg font-medium leading-[26px] md:text-xl md:leading-7"
            >
              Basic details
            </h2>
            <div class="mb-1 flex flex-col justify-between md:flex-row">
              <div
                class="mb-5 flex w-full justify-between flex-col items-start gap-2 md:max-w-[250px]"
              >
                <div class="">
                  <label
                    class="text-sm leading-5 text-dark-2 w-full max-w-[173px] md:max-w-[515px] md:w-[250px]"
                    for="financialYear"
                    >Financial year</label
                  >
                </div>
                <div
                  id="financialYear"
                  class="relative w-full md:min-w-[250px] md:max-w-[250px]"
                >
                  <div
                    class="flex h-[36px] cursor-pointer items-center justify-between rounded border px-2 md:px-3"
                  >
                    <div
                      class="flex items-center text-xs font-medium leading-4"
                    >
                      <span class="mr-2 text-xs">FY 2025 - 2026</span
                      ><span
                        class="ml-1 rounded-[4px] bg-primary-dark px-1 py-0.5 text-[8px] leading-none text-white"
                        >New</span
                      >
                    </div>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="keyboard_arrow_down_FILL0_wght400_GRAD0_opsz24 1">
                        <path
                          id="Vector"
                          d="M8 10.2666L4 6.26665L4.93333 5.33331L8 8.39998L11.0667 5.33331L12 6.26665L8 10.2666Z"
                          fill="black"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div
                class="mb-5 flex w-full justify-between flex-col items-start gap-2 md:max-w-[250px]"
              >
                <div class="">
                  <label
                    class="text-sm leading-5 text-dark-2 w-full max-w-[173px] md:max-w-[515px] md:w-[250px]"
                    for="ageGroup"
                    >Age group</label
                  >
                </div>
                <div
                  id="ageGroup"
                  class="relative w-full md:min-w-[250px] md:max-w-[250px]"
                >
                  <div
                    class="flex h-[36px] cursor-pointer items-center justify-between rounded border px-2 md:px-3"
                  >
                    <div
                      class="flex items-center text-xs font-medium leading-4"
                    >
                      <span class="mr-2 text-xs">0-59 yrs</span>
                    </div>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="keyboard_arrow_down_FILL0_wght400_GRAD0_opsz24 1">
                        <path
                          id="Vector"
                          d="M8 10.2666L4 6.26665L4.93333 5.33331L8 8.39998L11.0667 5.33331L12 6.26665L8 10.2666Z"
                          fill="black"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div
                class="mb-5 flex w-full justify-between flex-col items-start gap-2 md:max-w-[250px]"
              >
                <div class="">
                  <label
                    class="text-sm leading-5 text-dark-2 w-full max-w-[173px] md:max-w-[515px] md:w-[250px]"
                    for="cityType"
                    >My city is a</label
                  >
                </div>
                <div
                  id="cityType"
                  class="relative w-full md:min-w-[250px] md:max-w-[250px]"
                >
                  <div
                    class="flex h-[36px] cursor-pointer items-center justify-between rounded border px-2 md:px-3"
                  >
                    <div
                      class="flex items-center text-xs font-medium leading-4"
                    >
                      <span class="mr-2 text-xs">Metro</span>
                    </div>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="keyboard_arrow_down_FILL0_wght400_GRAD0_opsz24 1">
                        <path
                          id="Vector"
                          d="M8 10.2666L4 6.26665L4.93333 5.33331L8 8.39998L11.0667 5.33331L12 6.26665L8 10.2666Z"
                          fill="black"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full md:text-right">
              <button
                class="cursor-pointer px-4 py-2 text-sm font-semibold disabled:cursor-not-allowed hover-none:bg-primary-dark bg-primary-base text-white active:bg-primary-dark2 disabled:bg-primary-base/50 dark:bg-purpleDark-4 rounded-full w-full md:w-[180px]"
              >
                Continue
              </button>
            </div>
          </form>
        </div>
        <div class="tax-seo-content">
          <h3>The Upstox Income Tax Calculator</h3>
          <p>
            The Upstox Income Tax Calculator helps you calculate the applicable
            Income Tax based on your overall income and the tax liability as per
            your tax slab. To use the calculator, simply enter relevant details
            such as your salary, rent, capital gains, etc. and any applicable
            exemptions and deductions. You will then know the exact tax
            liability and also get smart insights on how to reduce your tax
            liability. You can use the Upstox IT calculator to compare taxes in
            the new and old tax regime. Both the regimes have different methods
            of calculating the exemptions and deductions and the tax you pay may
            differ. The one suitable for an individual depends on different
            metrics like salary bracket, allowances, deductions (PF, New Pension
            Scheme, Mutual Fund, etc) and more.
          </p>
          <h3>Latest Income Tax Slab and Rates - FY 2025-26 | AY 2026-27</h3>
          <div class="mb-10 flex flex-col gap-10 md:flex-row">
            <table class="w-full md:w-1/2">
              <tbody>
                <tr class="bg-light-1">
                  <td
                    colspan="2"
                    class="!p-4 !text-left !text-lg !font-semibold !leading-[26px]"
                  >
                    New Tax Regime (FY 2025-26): Income Tax Slabs For All Age
                    Groups
                  </td>
                </tr>
                <tr>
                  <td><p>Income tax slabs (Rs)</p></td>
                  <td><p>Income tax rate (%)</p></td>
                </tr>
                <tr>
                  <td><p>From 0 to 4,00,000</p></td>
                  <td><p>0</p></td>
                </tr>
                <tr>
                  <td><p>From 4,00,001 to 8,00,000</p></td>
                  <td><p>5</p></td>
                </tr>
                <tr>
                  <td><p>From 8,00,001 to 12,00,000</p></td>
                  <td><p>10</p></td>
                </tr>
                <tr>
                  <td><p>From 12,00,001 to 16,00,000</p></td>
                  <td><p>15</p></td>
                </tr>
                <tr>
                  <td><p>From 16,00,001 to 20,00,000</p></td>
                  <td><p>20</p></td>
                </tr>
                <tr>
                  <td><p>From 20,00,001 and 24,00,000</p></td>
                  <td><p>25</p></td>
                </tr>
                <tr>
                  <td><p>From 24,00,001 and Above</p></td>
                  <td><p>30</p></td>
                </tr>
              </tbody>
            </table>
            <table class="w-full md:w-1/2">
              <tbody>
                <tr class="bg-light-1">
                  <td
                    colspan="2"
                    class="!p-4 !text-left !text-lg !font-semibold !leading-[26px]"
                  >
                    Old Tax Regime: Income Tax Slabs For Individuals Below 60
                    Years
                  </td>
                </tr>
                <tr>
                  <td><p>Income tax slabs (Rs)</p></td>
                  <td><p>Income tax rates (%)</p></td>
                </tr>
                <tr>
                  <td><p>From 0 to 2,50,000</p></td>
                  <td><p>0</p></td>
                </tr>
                <tr>
                  <td><p>From 2,50,001 to 5,00,000</p></td>
                  <td><p>5</p></td>
                </tr>
                <tr>
                  <td><p>From 5,00,001 to 10,00,000</p></td>
                  <td><p>20</p></td>
                </tr>
                <tr>
                  <td><p>From 10,00,001 and above</p></td>
                  <td><p>30</p></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mb-10 flex flex-col gap-10 md:flex-row">
            <table class="w-full md:w-1/2">
              <tbody>
                <tr class="bg-light-1">
                  <td
                    colspan="2"
                    class="!p-4 !text-left !text-lg !font-semibold !leading-[26px]"
                  >
                    Old Tax Regime: Income Tax Slabs For Senior Citizens (60 -
                    79 Years)
                  </td>
                </tr>
                <tr>
                  <td><p>Income tax slabs (Rs)</p></td>
                  <td><p>Income tax rates (%)</p></td>
                </tr>
                <tr>
                  <td><p>From 0 to 3,00,000</p></td>
                  <td><p>0</p></td>
                </tr>
                <tr>
                  <td><p>From 3,00,001 to 5,00,000</p></td>
                  <td><p>5</p></td>
                </tr>
                <tr>
                  <td><p>From 5,00,001 to 10,00,000</p></td>
                  <td><p>20</p></td>
                </tr>
                <tr>
                  <td><p>From 10,00,001 and above</p></td>
                  <td><p>30</p></td>
                </tr>
              </tbody>
            </table>
            <table class="w-full md:w-1/2">
              <tbody>
                <tr class="bg-light-1">
                  <td
                    colspan="2"
                    class="!p-4 !text-left !text-lg !font-semibold !leading-[26px]"
                  >
                    Old Tax Regime: Income Tax Slabs For Super Senior Citizens
                    (80 Years and above)
                  </td>
                </tr>
                <tr>
                  <td><p>Income tax slabs (Rs)</p></td>
                  <td><p>Income tax rates (%)</p></td>
                </tr>
                <tr>
                  <td><p>From 0 to 5,00,000</p></td>
                  <td><p>0</p></td>
                </tr>
                <tr>
                  <td><p>From 5,00,001 to 10,00,000</p></td>
                  <td><p>20</p></td>
                </tr>
                <tr>
                  <td><p>From 10,00,001 and above</p></td>
                  <td><p>30</p></td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3>What is the Income Tax Filing Process?</h3>
          <p class="!font-semibold">
            Here’s a step-by-step guide on how you can file your Income Tax
            returns on the ITR portal:
          </p>
          <ol>
            <li>
              Select the year you earned the income and the relevant assessment
              year. For instance, for income earned during the financial year
              2023-24, the correct assessment year would be 2024-25.
            </li>
            <li>
              Select the ITR form applicable to you, from Form 1 to Form 4<br />Select
              whether it’s an ‘Original’ or ‘Revised’ return
            </li>
            <li>Pick ‘Online Submission’ mode.</li>
            <li>
              Select your status from - Individual, Hindu Undivided Family
              (HUF), Firm, or LLP.
            </li>
            <li>Submit relevant information (For ITR 1):</li>
          </ol>
          <ul class="!my-6">
            <li>
              <strong>Personal:</strong> Name, address, bank account, Aadhaar
              number, PAN
            </li>
            <li>
              <strong>Income (Gross)</strong>: Income from all sources must be
              disclosed, including salary, house property, pension, or any other
              source. Details of exempt income, if any, must also be provided
            </li>
            <li>
              <strong>Deductions</strong>: Claim all the deductions that you are
              entitled to under sections 80C, 80TTA, 80TTB, 80D, and others
            </li>
            <li>
              <strong>Taxes Already Paid</strong>: This covers the taxes you
              have already paid, including but not limited to TDS, Advance Tax,
              TCS, and Self-Assessment Tax
            </li>
            <li>
              <strong>Tax Liability</strong>: This section will display your tax
              obligation based on the details shared in the earlier sections
            </li>
          </ul>
          <p class="!mb-6 !font-semibold">
            Here’s what happens after filing your ITR:
          </p>
          <h4><strong>1. Refund</strong></h4>
          <p>
            If the calculation results in a negative amount, you are eligible
            for a tax refund. Here’s what happens next:
          </p>
          <ul class="!mb-6">
            <li>
              <strong>Refund Process</strong>: If you paid more taxes than
              required, the Income Tax Department will credit the refund to your
              account.
            </li>
            <li>
              <strong>Timeframe</strong>: The refund is expected to be credited
              within 30 days of filing the returns.
            </li>
          </ul>
          <h4><strong>2. Tax Payable</strong></h4>
          <p>
            If the calculation results in a positive amount, it means you have a
            tax liability. Here’s what you need to do:
          </p>
          <ul class="!mb-6">
            <li>
              <strong>Paying the Tax</strong>: You need to pay the outstanding
              tax amount. This can be done online through the Income Tax
              Department's website or through designated banks.
            </li>
            <li>
              <strong>Interest and Penalties</strong>: Ensure timely payment to
              avoid interest and penalties for late payment. Interest is
              calculated under Sections 234B and 234C of the Income Tax Act for
              late payment of advance tax.
            </li>
            <li>
              <strong>Final Calculation</strong>: After payment, update the
              details of the tax paid in your return form. This includes
              providing the Challan Identification Number (CIN) and other
              relevant details.
            </li>
          </ul>
          <h4><strong>3. Final Steps</strong></h4>
          <p>
            At the end of the exercise, you will see your tax computation sheet.
            However, there’s an important step left: eVerifying the tax
            calculation.
          </p>
          <ul class="!mb-6">
            <li>
              <strong>eVerify</strong>: Generate an OTP using your Aadhaar card.
              You can also e-verify by generating an Electronic Verification
              Code (EVC) on your bank or Demat portal. Remember that
              verification is a mandatory step.
            </li>
            <li>
              <strong>Submit</strong>: After verification, submit the form, and
              you are done.
            </li>
          </ul>
          <h3>Penalty for Late Filing</h3>
          <p>
            Note that there’s a penalty imposed by the Income Tax Department if
            you delay filing your taxes.
          </p>
          <ul class="!mb-6">
            <li>
              <strong>Deadline</strong>: For salaried employees, the last date
              to file your taxes is 31 July.
            </li>
            <li>
              <strong>Penalty</strong>: If you file after this date, you will be
              charged a penalty.
            </li>
          </ul>
          <h3><strong>Acknowledgment</strong></h3>
          <p>
            As the final step, the Income Tax Department will send an
            acknowledgment email to your registered email address.
          </p>
          <p>
            By completing these steps, you ensure that your tax filing process
            is accurate and compliant with the regulations.
          </p>
          <table>
            <tbody>
              <tr>
                <td>
                  <p><strong>Step</strong></p>
                </td>
                <td>
                  <p><strong>Details</strong></p>
                </td>
              </tr>
              <tr>
                <td><p>1. Assessment Year</p></td>
                <td>
                  <p>
                    Select the year corresponding to the income earned, e.g.,
                    for 2023-24 income, choose 2024-25.
                  </p>
                </td>
              </tr>
              <tr>
                <td><p>2. ITR Form</p></td>
                <td>
                  <p>
                    Choose either ITR 1 or ITR 4 based on your income profile
                    for online submission.
                  </p>
                </td>
              </tr>
              <tr>
                <td><p>3. Return Type</p></td>
                <td>
                  <p>Specify if the return is 'Original' or 'Revised '.</p>
                </td>
              </tr>
              <tr>
                <td><p>4. Submission Mode</p></td>
                <td><p>Opt for online submission mode.</p></td>
              </tr>
              <tr>
                <td><p>5. Taxpayer Status</p></td>
                <td>
                  <p>Indicate your status as Individual, HUF, Firm, or LLP.</p>
                </td>
              </tr>
              <tr>
                <td><p>6. Personal Information</p></td>
                <td>
                  <p>
                    Provide Name, Address, Bank Account details, Aadhaar number,
                    and PAN.
                  </p>
                </td>
              </tr>
              <tr>
                <td><p>7. Income details</p></td>
                <td>
                  <p>
                    Disclose Gross Income from all sources including exemptions.
                  </p>
                </td>
              </tr>
              <tr>
                <td><p>8. Deductions</p></td>
                <td>
                  <p>
                    Claim deductions under sections 80C, 80TTA, 80TTB, 80D, and
                    others.
                  </p>
                </td>
              </tr>
              <tr>
                <td><p>9. Tax Already Paid</p></td>
                <td>
                  <p>
                    Include tax payments like TDS, Advance Tax, TCS, and
                    Self-Assessment Tax.
                  </p>
                </td>
              </tr>
              <tr>
                <td><p>10. Tax Liability</p></td>
                <td>
                  <p>
                    Tax liability: Tax applicable on taxable income - Tax Paid =
                    Tax Payable.
                  </p>
                </td>
              </tr>
              <tr>
                <td><p>11. Outcome</p></td>
                <td>
                  <p>
                    Determine if you are due for a refund or need to pay taxes
                    based on the computation.
                  </p>
                </td>
              </tr>
              <tr>
                <td><p>12. Submission and Completion</p></td>
                <td>
                  <p>
                    Submit the form online after completing all necessary
                    sections.
                  </p>
                </td>
              </tr>
              <tr>
                <td><p>13. Penalty</p></td>
                <td>
                  <p>
                    Note down the potential penalties for late filing. Deadline:
                    July 31 for salaried individuals.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-9 pb-16">
          <h2 class="text-lg text-lighter-black py-6 m-0 font-semibold">
            Frequently Asked Questions
          </h2>
          <div class="mb-4 border-b border-b-gray-accent2 pb-4"  @click="changeTab(1,$event)">
            <div>
              <div class="cursor-pointer">
                <div
                  class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                  :data-state="tab[1]?'open':'closed'"
                >
                  <span
                    class="basis-11/12 text-sm font-semibold text-lighter-black md:basis-full"
                    >What is the Upstox Income Tax Calculator?</span
                  ><span
                    class="block text-lg font-bold group-data-[state=open]:rotate-180"
                    ><img
                      alt="chevron-up"
                      loading="lazy"
                      width="20"
                      height="20"
                      decoding="async"
                      data-nimg="1"
                      style="color: transparent"
                      src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg"
                  /></span>
                </div>
              </div>
              <div
                class="overflow-hidden transition-all duration-300 ease-in-out font-medium text-base text-dark-1 block"
                :style="{maxHeight: tab[1]?content1?.scrollHeight+'px':'0px'}"
              >
                <div ref="content1"
                  class="pr-4 text-base pb-2 pt-2 text-gray-dark font-medium leading-6 tracking-[-0.18px]"
                >
                  The Upstox Income Tax Calculator is an online tool designed to
                  help taxpayers calculate their taxes based on their tax slab
                  and liability. It guides users through the process
                  step-by-step, simplifying tax calculations.
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4 border-b border-b-gray-accent2 pb-4" @click="changeTab(2,$event)">
            <div>
              <div class="cursor-pointer">
                <div
                  class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                  :data-state="tab[2]?'open':'closed'"
                >
                  <span
                    class="basis-11/12 text-sm font-semibold text-lighter-black md:basis-full"
                    >What does the Upstox Income Tax Calculator provide?</span
                  ><span
                    class="block text-lg font-bold group-data-[state=open]:rotate-180"
                    ><img
                      alt="chevron-up"
                      loading="lazy"
                      width="20"
                      height="20"
                      decoding="async"
                      data-nimg="1"
                      style="color: transparent"
                      src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg"
                  /></span>
                </div>
              </div>
              <div
                class="overflow-hidden transition-all duration-300 ease-in-out font-medium text-base text-dark-1 block"
                :style="{maxHeight: tab[2]?content2?.scrollHeight+'px':'0px'}"
              >
                <div ref="content2"
                  class="pr-4 text-base pb-2 pt-2 text-gray-dark font-medium leading-6 tracking-[-0.18px]"
                >
                  <div>
                    <p>The Upstox Income Tax Calculator helps you to:</p>
                    <p>- Compare tax liability in the old and new regimes.</p>
                    <p>
                      - Gain valuable insights on which regime is better for
                      you.
                    </p>
                    <p>
                      - Gain smart insights on how you can optimize your tax
                      savings.
                    </p>
                    <p>- Estimate your taxable income.</p>
                    <p>- Estimate the income tax payable.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4 border-b border-b-gray-accent2 pb-4" @click="changeTab(3,$event)">
            <div>
              <div class="cursor-pointer">
                <div
                  class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                  :data-state="tab[3]?'open':'closed'"
                >
                  <span
                    class="basis-11/12 text-sm font-semibold text-lighter-black md:basis-full"
                    >What are the benefits of the Upstox Income Tax
                    Calculator?</span
                  ><span
                    class="block text-lg font-bold group-data-[state=open]:rotate-180"
                    ><img
                      alt="chevron-up"
                      loading="lazy"
                      width="20"
                      height="20"
                      decoding="async"
                      data-nimg="1"
                      style="color: transparent"
                      src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg"
                  /></span>
                </div>
              </div>
              <div
                class="overflow-hidden transition-all duration-300 ease-in-out font-medium text-base text-dark-1 block"
                :style="{maxHeight: tab[3]?content3?.scrollHeight+'px':'0px'}"
              >
                <div ref="content3"
                  class="pr-4 text-base pb-2 pt-2 text-gray-dark font-medium leading-6 tracking-[-0.18px]"
                >
                  <div>
                    <p>
                      There are a number of advantages of using the Upstox
                      Income Tax Calculator, these include:<br />
                    </p>
                    <br />
                    <ol>
                      <li>
                        1.
                        <strong>Fast and speedy calculations:</strong> Performs
                        tax calculations quickly according to the Income Tax
                        Act, rules, and other provisions.
                      </li>
                      <li>
                        2. <strong> Basic Tax Overview:</strong> Provides a
                        quick view of basic tax calculations.
                      </li>
                      <li>
                        3. <strong> Comparison of Tax Regimes:</strong> Allows
                        you to compare tax liabilities under the old and new tax
                        regimes.
                      </li>
                      <li>
                        4. <strong> Smart insights:</strong> Gain expert
                        insights on how and where you can save on taxes
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4 border-b border-b-gray-accent2 pb-4" @click="changeTab(4,$event)">
            <div>
              <div class="cursor-pointer">
                <div
                  class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                  :data-state="tab[4]?'open':'closed'"
                >
                  <span
                    class="basis-11/12 text-sm font-semibold text-lighter-black md:basis-full"
                    >How to use the Upstox Income Tax Calculator online?</span
                  ><span
                    class="block text-lg font-bold group-data-[state=open]:rotate-180"
                    ><img
                      alt="chevron-up"
                      loading="lazy"
                      width="20"
                      height="20"
                      decoding="async"
                      data-nimg="1"
                      style="color: transparent"
                      src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg"
                  /></span>
                </div>
              </div>
              <div
                class="overflow-hidden transition-all duration-300 ease-in-out font-medium text-base text-dark-1 block"
                :style="{maxHeight: tab[4]?content4?.scrollHeight+'px':'0px'}"
              >
                <div ref="content4"
                  class="pr-4 text-base pb-2 pt-2 text-gray-dark font-medium leading-6 tracking-[-0.18px]"
                >
                  <div>
                    <p>Follow these steps to use our Income Tax calculator:</p>
                    <br />
                    <ol>
                      <li>
                        1. <strong>Select Financial Year:</strong> Choose the
                        relevant financial year.
                      </li>
                      <li>
                        2. <strong>Select Age:</strong> Choose the applicable
                        age bracket.
                      </li>
                      <li>
                        3. <strong>Select Residency:</strong> Indicate if you
                        are a resident of a metro/non-metro city.
                      </li>
                      <li>
                        4. <strong>Enter Income:</strong> Go to the 'Income' tab
                        and enter your gross salary, including income from
                        self-occupied or rent-out property
                      </li>
                      <li>and other incomes.</li>
                      <li>
                        5. <strong>Enter HRA Details:</strong> Provide details
                        for HRA exemptions, including basic salary, DA, actual
                        rent paid and HRA allowance.
                      </li>
                      <li>
                        6. <strong>Enter Deductions:</strong> Provide details of
                        all deductions (Sections 80C, 80CCD, 80D, 80G, 80E,
                        80TTA, 80TTB, 80GG)
                      </li>
                      <li>
                        7. <strong>Submit:</strong> The calculator will then
                        compute and provide details of your tax liability.
                      </li>
                    </ol>
                    <br />
                    <p>
                      <strong>Note:</strong> The calculator provides tax
                      liabilities for both the old and new tax regimes, enabling
                      a better comparison for decision-making.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-4 border-b border-b-gray-accent2 pb-4" @click="changeTab(5,$event)">
            <div>
              <div class="cursor-pointer">
                <div
                  class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                  :data-state="tab[5]?'open':'closed'"
                >
                  <span
                    class="basis-11/12 text-sm font-semibold text-lighter-black md:basis-full"
                    >What is professional tax?</span
                  ><span
                    class="block text-lg font-bold group-data-[state=open]:rotate-180"
                    ><img
                      alt="chevron-up"
                      loading="lazy"
                      width="20"
                      height="20"
                      decoding="async"
                      data-nimg="1"
                      style="color: transparent"
                      src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg"
                  /></span>
                </div>
              </div>
              <div
                class="overflow-hidden transition-all duration-300 ease-in-out font-medium text-base text-dark-1"
                :style="{maxHeight: tab[5]?content5?.scrollHeight+'px':'0px'}"
              >
                <div ref="content5"
                  class="pr-4 text-base pb-2 pt-2 text-gray-dark font-medium leading-6 tracking-[-0.18px]"
                >
                  Profession tax is the tax levied and collected by the state
                  governments in India. Its applicable on income from salary or
                  fees collected by professionals such as chartered accountants,
                  company secretaries, cost accountants, lawyers, doctors etc.
                  The maximum professional tax is ₹2,500, as per Article 276.
                  Non-payment can result in penalties and interest for late
                  payment.
                </div>
              </div>
            </div>
          </div>
          <div class="" @click="changeTab(6,$event)">
            <div>
              <div class="cursor-pointer">
                <div
                  class="group flex w-full items-start justify-between px-0 py-2 text-left md:items-center md:leading-10 text-sm font-semibold"
                 :data-state="tab[6]?'open':'closed'"
                >
                  <span
                    class="basis-11/12 text-sm font-semibold text-lighter-black md:basis-full"
                    >What is the tax calculation formula?</span
                  ><span
                    class="block text-lg font-bold group-data-[state=open]:rotate-180"
                    ><img
                      alt="chevron-up"
                      loading="lazy"
                      width="20"
                      height="20"
                      decoding="async"
                      data-nimg="1"
                      style="color: transparent"
                      src="@/styles/img/calculator/next-calculator-assets/ChevronDown.svg"
                  /></span>
                </div>
              </div>
              <div
                class="overflow-hidden transition-all duration-300 ease-in-out font-medium text-base text-dark-1"
                :style="{maxHeight: tab[6]?content6?.scrollHeight+'px':'0px'}"
              >
                <div ref="content6"
                  class="pr-4 text-base pb-2 pt-2 text-gray-dark font-medium leading-6 tracking-[-0.18px]"
                >
                  Net tax payable = Taxable income - applicable tax on taxable
                  income - tax already paid
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped>
</style>
